import { useCallback, useEffect } from "react"
import { postSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { isLoadingModal, isOpenProvidersSuppliersMappingModal, selectedTable } from "Pages/Admin/ProvidersSuppliersMapping/@signals"

export default function useProvidersSuppliersMappingNormalization(normalizedData) {
	
	const onSubmitNormalization = useCallback(() => {
		postSubmit(`${BACKEND_APIS.ADMIN}/normalize/${selectedTable.value}`, {
			rawData: isOpenProvidersSuppliersMappingModal.value.map(({ rawData }) => rawData),
			normalizedData
		})
			.then(() => {
				isLoadingModal.value = false
				isOpenProvidersSuppliersMappingModal.value = []
			})
	}, [normalizedData, isOpenProvidersSuppliersMappingModal.value])

	useEffect(() => {
		if (!!isLoadingModal.value && !!normalizedData) onSubmitNormalization()
	}, [isLoadingModal.value])

	return {
		isLoading: isLoadingModal.value,
	}
}